export const enum FeatureFlags {
  aprPdpFeature = 'product.aprPdpFeature',
  pdpSeoRoute = 'product.pdpSeoRoute',
  productBundleAccordion = 'product.productBundleAccordion',
  showBV = 'product.showBV',
  showRetailPrices = 'product.showRetailPrices',
  sopFeature = 'product.sopFeature',
  sopPdpFeature = 'product.sopPdpFeature',
  pdpProductGalleryV2 = 'product.pdpProductGalleryV2',
  sopSellableOnly = 'product.sopSellableOnly',
}
